<section class="text-center mt-2">
  <h1>Server Error</h1>
  <p>There was a server error during this request.</p>
  <a [routerLink]="['/dashboard']" class="btn btn-primary">Return to Your Dashboard</a>
</section>
